import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Validators } from '@angular/forms';
import { UserServiceV2 } from '@app/v2/services/user-service/user.service';
import { MdsDropdownComponent, MdsTextFieldComponent } from '@medpacesoftwaredevelopment/designsystem';
import { Currency } from '@models/currency';
import { CurrencyStateService } from '@services/state-management/currency-state.service';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { notWhitespaceValidator } from '@utility/utility.validators';
import { switchMap } from 'rxjs';

@Component({
    selector: 'medpace-payment-request-deduction-edit',
    imports: [MdsTextFieldComponent, MdsDropdownComponent, AsyncPipe],
    templateUrl: './payment-request-deduction-edit.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentRequestDeductionEditComponent {
    formGrp = input.required<PaymentRequestDeductionFormGroup>();
    formGrp$ = toObservable(this.formGrp);
    currency$ = this.formGrp$.pipe(switchMap((formGrp) => formGrp.controls.currency.valueChangesReplay));
    currencyOptions$ = inject(CurrencyStateService).getCurrenciesAsMdsOptions();
    elevatedAccess$ = inject(UserServiceV2).permissions.request.access.elevated$;
}
export class PaymentRequestDeductionFormGroup extends PersistentFormGroup<{
    amount: PersistentFormControl<number>;
    amountConverted: PersistentFormControl<number>;
    currency: PersistentFormControl<Currency>;
}> {
    constructor() {
        super({
            amount: new PersistentFormControl<number>(null, [
                Validators.required,
                notWhitespaceValidator(),
                Validators.min(-1e6),
                Validators.max(1e6),
            ]),
            amountConverted: new PersistentFormControl<number>(null, [Validators.min(-1e6), Validators.max(1e6)]),
            currency: new PersistentFormControl<Currency>(null, [Validators.required]),
        });
    }
}
